import { Container } from '@mui/material';
import image6 from '../assets/quran_images.jpg';

const AboutInfo = () => {
  return (
    <Container>
      <div className="about-info">
        <div className="vc-image">
          <img src={image6} alt="Wise Kidz" />
        </div>
        <div className="vc-office">
          <h2>About Us</h2>

          <h3>Our Mission</h3>
          <p>
            At Wise Kidz, we help kids become thinkers, question-askers, and kind humans!
            We learn with logic, explore with curiosity, and grow with kindness — all while having fun!
          </p>

          <h3>Our Vision</h3>
          <p>
            We dream of a world full of wise kids who solve problems, help others, and make the world a better place — one smart question at a time.
          </p>

          <h3>A Note from the Founder</h3>
          <p><strong>Welcome to Wise Kidz!</strong></p>
          <p>
            When we started Wise Kidz, our goal was simple — to create a place where children aren’t just taught what to think, but how to think. 
            Let’s be honest: learning can sometimes feel like just checking boxes and memorizing stuff you’ll never use. 
            At Wise Kidz, we’re flipping that idea on its head.
          </p>
          <p>
            Our approach is built on four key values: <strong>Wisdom, Identity, Service,</strong> and <strong>Education</strong>. 
            These aren’t just words on a wall — they guide everything we do, from how we teach to how we treat each other.
          </p>
          <p>
            We’re not here to turn you into a walking textbook. We’re here to help you think for yourself, ask better questions, and 
            see the world through a lens of logic, purpose, and real understanding <em>(yes, it’s allowed to make sense 😄)</em>.
          </p>
          <p>
            At Wise Kidz, learning is joyful, thoughtful, and meaningful. We believe wisdom is cooler than just being “smart,” 
            and being kind is just as powerful as being clever.
          </p>
          <p>
            You’ve got a brain. You’ve got potential. Let’s use both. Because real education isn’t just about grades — 
            it’s about becoming someone who thinks clearly, acts kindly, and lives with purpose.
          </p>
        </div>
      </div>
    </Container>
  );
};

export default AboutInfo;
